module.exports = __webpack_public_path__ + "images/svg/bg_green_bubbles.png";